// SAD-441 (C3-02): a mapping is ONE stored decision (from -> target) read
// from either endpoint. Equivalent reads the same both ways; Broader/Narrower
// reverse at the other endpoint. The reversal is a read-time view — it never
// implies, or needs, a second approval.
export const MAPPING_TYPE_LABELS = {
    EQUIVALENT: 'Equivalent to',
    BROADER: 'Broader than',
    NARROWER: 'Narrower than'
};
const REVERSE_MAPPING_TYPE = {
    EQUIVALENT: 'EQUIVALENT',
    BROADER: 'NARROWER',
    NARROWER: 'BROADER'
};
const label = (type)=>(MAPPING_TYPE_LABELS[type] ?? type).toLowerCase();
export const mappingTarget = (m)=>m.toAnchorId ? `${m.toAnchorSocCode} ${m.toAnchorTitle}` : m.toEntryTitle || m.toEntryId;
/** The relation as stored: "<from> is <relation> <target>". */ export const mappingStatement = (m)=>`${m.status === 'REVIEW_NEEDED' ? 'Historical approval; review needed: ' : ''}${m.fromEntryTitle} is ${label(m.mappingType)} ${mappingTarget(m)}`;
/**
 * The statement as seen from `entryId`'s side. From the stored from-side it is
 * the stored sentence; from the to-side Broader/Narrower swap.
 */ export const mappingViewFrom = (m, entryId, entryTitle)=>{
    if (m.toEntryId !== entryId && m.currentToEntryId !== entryId || m.fromEntryId === entryId || m.currentFromEntryId === entryId) {
        return {
            statement: mappingStatement(m),
            reversed: false
        };
    }
    return {
        statement: `${m.status === 'REVIEW_NEEDED' ? 'Historical approval; review needed: ' : ''}${entryTitle} is ${label(REVERSE_MAPPING_TYPE[m.mappingType] ?? m.mappingType)} ${m.fromEntryTitle}`,
        reversed: true,
        note: `Same reviewed decision as seen from ${m.fromEntryTitle}'s side — not a second approval.`
    };
};
export const MAPPING_STATE_LABELS = {
    MAPPED: 'Mapped',
    PENDING_REVIEW: 'Pending review',
    REVIEW_NEEDED: 'Review needed',
    UNMAPPED: 'Unmapped'
};
/** Unmapped is a valid state: only an approved/pending edge at either end changes it. */ export const mappingStateFor = (entryId, mappings)=>{
    const related = mappings.filter((m)=>m.fromEntryId === entryId || m.toEntryId === entryId || m.currentFromEntryId === entryId || m.currentToEntryId === entryId);
    if (related.some((m)=>m.status === 'APPROVED')) return 'MAPPED';
    if (related.some((m)=>m.status === 'PENDING')) return 'PENDING_REVIEW';
    if (related.some((m)=>m.status === 'REVIEW_NEEDED')) return 'REVIEW_NEEDED';
    return 'UNMAPPED';
};
